var body = document.body;
var sc = (function(){
	var scrollElement = 'scrollingElement' in document ? document.scrollingElement : document.documentElement;
	var scrollPoint,prePoint,flag;
	return function(){
		scrollPoint = scrollElement.scrollTop;
		flag = prePoint > scrollPoint ? true : false;
		prePoint = scrollPoint;
		return flag;
	}
})();

window.addEventListener("scroll",function(){
	if(sc()){
		body.classList.remove("scrl_down");
	}else{
		body.classList.add("scrl_down");
	}
});

var links = document.links;
for (let i = 0, linksLength = links.length ; i < linksLength ; i++) {
	if (links[i].hostname !== window.location.hostname) {
		links[i].target = '_blank';
		links[i].relList.add('noreferrer', 'noopener');
	}
}

$(function(){

var body=$('body');
var winH = $(window).height();
var winW = $(window).width();
var scrTop = 1;

$(window).on('resize',function(){
	winH = $(window).height();
	winW = $(window).width();
	delayAnime();
});
$(window).on('scroll',function(){
	scrTop = $(window).scrollTop();
	delayAnime();
});

function delayAnimeInt(){
	if(window.matchMedia('(min-width:767px)').matches){
		delayHeight = 0;
	}else{
		delayHeight = 0;
	}
	delaySet();
	delayAnime();
	scrlClass();
}
function delaySet(){
	var setElm = $('.anime');
	setElm.each(function(){
		var setThis = $(this),
		obj = setThis.find(".obj"),
		elmHeight = setThis.height();
		for(var i=0;i<obj.length;i++){
			var delaytime = i*200;
			obj.eq(i).css({transitionDelay: delaytime+'ms' });	
		}
	});
}
function delayAnime(){
	scrTop = $(window).scrollTop();
	var setElm = $('.anime');
	setElm.each(function(){
		var setThis = $(this),
		elmHeight = setThis.height(),
		elmTop = setThis.offset().top;
		if (scrTop > elmTop - winH + delayHeight && scrTop < elmTop + elmHeight){
			setThis.addClass("active");
		}
	});
	var sElm = $('.elm');
	sElm.each(function(){
		var setThis = $(this),
		elmHeight = setThis.height(),
		elmTop = setThis.offset().top;
		if (scrTop > elmTop - winH + delayHeight && scrTop < elmTop + elmHeight){
			setThis.addClass("active");
		}
	});
	scrlClass();
}


function scrlClass(){
	if(scrTop===0){
		body.addClass("scrl_top");
		body.removeClass("scrl");
	}else if(scrTop>0){
		body.removeClass("scrl_top");
		body.addClass("scrl");
	}
	if(scrTop>winH/2){
		body.addClass("scrl_halfview");
	}else{
		body.removeClass("scrl_halfview");
	}
}

$('#searchBtn').on('click', function(){
	$('#Search_inline').toggleClass('active');
});

$('#drawerBtn').on('click',function(){
	body.toggleClass('navopen');
});

function newsletterFunc(){
	var $newsletterblock = $('#newsletterblock');
$('#newsletter_btn').on('click',function(){
	$newsletterblock.toggleClass('active');
});
$('#newsletterclose').on('click',function(){
	$newsletterblock.removeClass('active');
});
}


var swiper;
var slider_total;
function imageSlide(){
	let $slider = $('#slider');
	swiper = new Swiper('#imgSwiper', {
		effect: 'slide',
		speed: 1400,
		spaceBetween: 0,
		preventClicks: false,
		preventClicksPropagation: false,
		loop: true,
		autoplay: {
			delay: 4000,
			disableOnInteraction: false,
		},
		keyboard: {
			onlyInViewport: false,
		},
		pagination: {
			el: '.swiper-pagination',
			type: 'bullets',
			clickable: true,
		},
		fadeEffect: {
			crossFade: true
		},
  	init: false,
	});

	var $prev = $('.current_prev');
	var $count = $('.current_count');
	var $name = $('.current_name');
	var $next = $('.current_next');
	var current_num;
	var current_elm;
	swiper.on('init', function () {
		$slider.delay(300).queue(function() {
			startSlide();
		});
		current_num = swiper.realIndex+1;
		current_elm = swiper.slides[current_num];
		updateinfo($(current_elm), $prev, $count, $name, $next);
		$prev.on('click', function(){
			swiper.slidePrev();
		})
		$next.on('click', function(){
			swiper.slideNext();
		})
	});
	swiper.init();
	swiper.on('slideChangeTransitionStart', function () {
		current_num = swiper.realIndex+1;
		current_elm = swiper.slides[current_num];
		updateinfo($(current_elm), $prev, $count, $name, $next);
	});
	swiper.on('slideChangeTransitionEnd', function () {
	});
}

function updateinfo(current_elm, $prev, $count, $name, $next){
	$prev.find('span').html(current_elm.find('.prev').text());
	$count.html(current_elm.find('.count').text());
	$name.html(current_elm.find('.name').text());
	$next.find('span').html(current_elm.find('.next').text());
}
function getdoubleDigestNumer(number) {
  return ("0" + number).slice(-2)
}

function startSlide(){
	swiper.autoplay.start();
}
function stopSlide(){
	swiper.autoplay.stop();
}

function videoModal(){
	var $videomodal = $('.videomodal');
	if($videomodal.length) {
		var modal = $videomodal.iziModal({
			width: '100%',
			iframe: true,
			iframeHeight: winH,
			navigateCaption: false,
			fullscreen: true,
			overlayColor: 'rgba(249,244,237,1)',
			transitionIn: 'fadeIn',
			transitionOut: 'fadeOut',
			closeButton: false,
			onOpening: function(modal){
			},
			onClosing: function(){
			},
			afterRender: function(){
			}
		});
		var data = (function () {/*
		<div class='modalclose' data-izimodal-close=''></div>
		*/}).toString().match(/(?:\/\*(?:[\s\S]*?)\*\/)/).pop().replace(/^\/\*/, "").replace(/\*\/$/, "");
		if( $videomodal.find('.modalclose').length == 0 ){
			$videomodal.append($(data));
		}

		$('iframe').attr('allowFullScreen', true);
	}
}


function modalSlide(){
	var galleryThumbs = new Swiper('.slider_thumb', {
		spaceBetween: 10,
		slidesPerView: 100,
		watchSlidesVisibility: true,
		watchSlidesProgress: true,
		threshold:20,
	});
	var galleryTop = new Swiper('.slider_img', {
		effect: 'fade',
		speed: 800,
		spaceBetween: 0,
		preventClicks: false,
		preventClicksPropagation: false,
		threshold:20,
		navigation: {
			nextEl: '.swiper-button-next',
			prevEl: '.swiper-button-prev',
		},
		thumbs: {
			swiper: galleryThumbs
		}
	});

	$('.modalbtn').on('click', function(){
		var slidenum = $(this).attr('data-slidenum') -1;
		galleryTop.slideTo(slidenum);
		body.addClass('modal');
	})
	$('.modalclose').on('click', function(){
		body.removeClass('modal');
	})
}


function keywordFunc(){
	var $keyword = $('#keyword');
	var $a_word = $('a-word');
	var $word = $('.word');
	var index;
	$a_word.on('click', function(){
		$word.css({'display':'none'});		
		index = $a_word.index(this);
		$word.eq(index).css({'display':'block'});
		$keyword.addClass('active');
		console.log(index);
	});
	$('#wordclosebtn').on('click', function(){
		$keyword.removeClass('active');
	})
}


function productInfo(){
	if(window.matchMedia( '(min-width: 641px) and (max-width: 1007px)' ).matches){
		$(window).on('load',function(){
			productInfoSticky();
		});
		$('.Collapsible__Button').on('click',function(){
			setTimeout(function(){
				productInfoSticky();
			},400);
		})
	}
}
function productInfoSticky(){
	const ch = document.documentElement.clientHeight;
	const sideBar = document.getElementById('Product__Info_id');
	const sh = sideBar.offsetHeight;
	sideBar.style.top = -(sh - ch) + 'px';
}


function Image_parent(){
	$(".txt_conetnts p:has(img)").addClass("hasimg");
	$(".txt_conetnts p:has(iframe)").addClass("video").wrap('<div class="hasvideo">');
}


$(window).on('load',function(){
	newsletterFunc();
	keywordFunc();
	Image_parent();
	delayAnimeInt();
});


if( document.getElementById('slider') ){
	imageSlide();
}

if( document.getElementById('collection') ){
	modalSlide();
	videoModal();
}

if( document.getElementById('shopify-section-product-template') ){
	productInfo();
}

if( document.getElementById('addresspage') ){
	$('.Modal').appendTo('body');
}


});
